import { Component, Input } from '@angular/core';
import { LegendGroup, LegendItem } from '../utilization-metric-box/utilization-metrics.interface';

@Component({
	selector: 'app-utilization-metric-box-legends',
	templateUrl: './utilization-metric-box-legends.component.html',
	styleUrls: ['./utilization-metric-box-legends.component.css']
})
export class UtilizationMetricBoxLegendsComponent {
	@Input() legendTitle: string = 'Legends';
	@Input() showLegend: boolean = true;
	@Input() legend: LegendItem[] = [];
	@Input() legendGroups: LegendGroup[] = [];

	constructor() { }
}
